import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["src", "alt"]

import { computed } from 'vue'

import Button from '@/components_new/Button.vue'
import SeoTextRaw from '@/components_new/SeoText/SeoTextRaw.vue'
import Typography from '@/components_new/Typography.vue'
import { APIGameType, GameCategoriesInfoType } from '@/types'

interface ExportInitScreenProps {
    game: APIGameType
    categories?: GameCategoriesInfoType
}


export default /*@__PURE__*/_defineComponent({
  __name: 'ExportInitScreen',
  props: {
    game: {},
    categories: {}
  },
  setup(__props: any) {

const props = __props
const gameCategories = computed(
    () => props.categories?.categoriesInfo.filter((cat) => cat.categoryType === 'category') || [],
)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(_ctx.$style.initScreen),
    "data-interface-target": "init_screen"
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(_ctx.$style.blurBg),
      style: _normalizeStyle({ '--bg': `url(${props.game.preview})` })
    }, null, 6),
    _createElementVNode("div", {
      class: _normalizeClass(_ctx.$style.content)
    }, [
      _createElementVNode("div", {
        class: _normalizeClass(_ctx.$style.imageAndButton)
      }, [
        _createElementVNode("img", {
          class: _normalizeClass(_ctx.$style.image),
          src: props.game.preview,
          alt: props.game.title,
          fetchpriority: "high"
        }, null, 10, _hoisted_1),
        _createVNode(Button, {
          interfaceTarget: "init_button",
          effect: "bevel",
          visual: "fill",
          size: "l",
          iconLeft: "play",
          class: _normalizeClass(_ctx.$style.initButton)
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$tr('gameContainer.init_button')), 1)
          ]),
          _: 1
        }, 8, ["class"])
      ], 2),
      _createElementVNode("div", {
        class: _normalizeClass(_ctx.$style.texts)
      }, [
        _createVNode(Typography, {
          is: "h1",
          type: "header",
          size: "s"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(props.game.title), 1)
          ]),
          _: 1
        }),
        _createVNode(Typography, {
          is: "div",
          type: "paragraph",
          size: "xs"
        }, {
          default: _withCtx(() => [
            _createElementVNode("span", {
              class: _normalizeClass(_ctx.$style.categoriesLabel)
            }, _toDisplayString(_ctx.$tr('gameDetails.categories')) + ": ", 3),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(gameCategories.value, (category, index) => {
              return (_openBlock(), _createElementBlock(_Fragment, {
                key: category.id
              }, [
                _createElementVNode("span", null, _toDisplayString(category.title), 1),
                _createTextVNode(_toDisplayString(index !== gameCategories.value.length - 1 ? ', ' : ''), 1)
              ], 64))
            }), 128))
          ]),
          _: 1
        }),
        _createElementVNode("div", {
          class: _normalizeClass(_ctx.$style.divider)
        }, null, 2),
        _createVNode(Typography, {
          is: "div",
          type: "paragraph",
          size: "xs",
          class: _normalizeClass(_ctx.$style.seoText)
        }, {
          default: _withCtx(() => [
            _createVNode(SeoTextRaw, {
              content: props.game.seo_text
            }, null, 8, ["content"])
          ]),
          _: 1
        }, 8, ["class"])
      ], 2)
    ], 2)
  ], 2))
}
}

})